import { ShieldCheck, Users, Award } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const BADGES = [
  { icon: ShieldCheck, label: "Licensed & Insured", sub: "Full NJ coverage" },
  { icon: Users, label: "Family-Owned", sub: "Since 1998" },
  { icon: Award, label: "26+ Years", sub: "Of craftsmanship" },
];

const FAQS = [
  {
    q: "Are you fully licensed and insured in New Jersey?",
    a: "Yes. Ardeca Construction is fully licensed and carries comprehensive liability and workers' compensation insurance throughout the state of New Jersey. We're happy to provide documentation before any project begins — your protection and peace of mind come first.",
  },
  {
    q: "What does 'family-owned' actually mean for me?",
    a: "It means the people quoting your project are the same people who stand behind the finished work. There's no faceless corporate handoff — you'll deal directly with our family, and our name (and reputation in your neighborhood) is on every job.",
  },
  {
    q: "Do you offer free estimates?",
    a: "Always. We provide free, no-pressure in-home estimates with transparent, itemized pricing. You'll know exactly what's included before you commit to anything.",
  },
  {
    q: "How do you keep projects clean and on schedule?",
    a: "We protect your floors and furniture, clean up daily, and give you a clear timeline up front. Our crews are respectful of your home and your routine — and we communicate every step of the way.",
  },
];

export default function TrustBadges() {
  return (
    <section data-testid="trust-section" className="bg-brand-creamSoft border-y border-brand-cream">
      <div className="container-x py-16 md:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <Reveal>
            <p className="eyebrow">Why Homeowners Trust Us</p>
            <h2 className="h2 mt-4">Built on Trust. Backed by Proof.</h2>
            <p className="lead mt-5">
              We know inviting a contractor into your home takes a leap of faith. That's why everything we do is
              transparent, documented, and stands behind the Ardeca family name.
            </p>

            <div className="mt-9 grid grid-cols-3 gap-3 sm:gap-4">
              {BADGES.map((b) => {
                const Icon = b.icon;
                return (
                  <div key={b.label} className="rounded-2xl bg-white border border-brand-cream p-4 sm:p-5 text-center shadow-sm">
                    <div className="mx-auto grid place-items-center h-11 w-11 rounded-xl bg-brand-orange/10 text-brand-orange">
                      <Icon size={20} strokeWidth={1.9} />
                    </div>
                    <p className="mt-3 text-sm font-bold text-brand-dark leading-tight">{b.label}</p>
                    <p className="text-xs text-brand-muted">{b.sub}</p>
                  </div>
                );
              })}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`trust-accordion-${i}`} className="border-b border-brand-cream">
                  <AccordionTrigger className="text-left text-base font-semibold text-brand-dark hover:text-brand-orange hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-muted text-sm leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
